import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
const PagesCommonHeader = ({ title, leftSection, rightSection, lastUpdatedSection, height = "auto", rightCss }) => {
    const showLeft = Boolean(leftSection || lastUpdatedSection || title);
    return (_jsxs(Box, { sx: {
            width: "100%",
            bgcolor: "#fff",
            borderRadius: "8px",
            border: "1px solid #D0D5DD",
            px: 2.5,
            py: 2,
            minHeight: height,
            height: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }, className: "pages-common-header-left", children: [_jsx(Box, { sx: { display: "flex", alignItems: "center", gap: 1, flex: 1 }, children: leftSection ? (leftSection) : lastUpdatedSection ? (lastUpdatedSection) : (title && (_jsx(Typography, { className: "head-Font-Sizes", sx: { fontWeight: 600, color: "#000" }, children: title }))) }), _jsx(Box, { sx: { display: "flex", alignItems: "center", gap: 2.5, }, className: rightCss, children: rightSection })] }));
};
export default PagesCommonHeader;
